export default "__VITE_ASSET__DKM5VKsx__"